module.exports = __webpack_public_path__ + "img/logo.ba043c74.png";